import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BackButton, Button, CardSpinner, ConfirmPopup, Icon } from '~/commonComponents';
import { ChargeTimelineDaysPopup } from '~/components/ChargeTimelineDaysPopup';
import { fireV0ShiftDetailsPageViewed, fireV0ShiftDetailsSubmitted } from '~/posthogs/events';
import {
  FETCH_AVERAGE_RATING,
  FETCH_FAVORITE_PROFESSIONALS,
  FETCH_RECENT_PROFESSIONALS,
  FETCH_RECOMMENDED_PROFESSIONALS_ACTION,
  GET_USER_OVERTIME_LIMITS_ACTION,
  SELECT_DEFAULT_INFO_MDB,
  selectDefaultInfoMDB,
} from '../../../../../actions';
import history from '../../../../../browserHistory';
import useLoading from '../../../../../hooks/useLoading';
import Form, { FORM_FIELDS } from '../../components/Form';
import { ProgressBar } from '../../components/ProgressBar';
import { useShiftDetailsStep } from '../../hooks/useShiftDetailsStep';

const actions = [
  SELECT_DEFAULT_INFO_MDB,
  FETCH_FAVORITE_PROFESSIONALS,
  FETCH_RECENT_PROFESSIONALS,
  FETCH_RECOMMENDED_PROFESSIONALS_ACTION,
  GET_USER_OVERTIME_LIMITS_ACTION,
  FETCH_AVERAGE_RATING,
];

export function ShiftDetailsContent() {
  const dispatch = useDispatch();
  const editedDate = history.location?.state?.editedDate || '';
  const currentJob = useSelector(
    (state) => state.multiday.jobInfo.filter((job) => job.localDate === editedDate)[0],
  );
  const {
    formValues,
    setFormValues,
    jobData,
    isDisabled,
    setConfirmationExitModalOpen,
    allowNavigation,
    confirmationExitModalOpen,
    clearPendingNavigation,
    navigateToPending,
  } = useShiftDetailsStep(currentJob);
  const { isLoading } = useLoading(actions);
  const jobDates = useSelector((state) => state.multiday.jobDates);

  const isButtonDisabled = isDisabled || !jobDates?.length;

  useEffect(() => {
    fireV0ShiftDetailsPageViewed();
  }, []);

  const handleNextButton = () => {
    fireV0ShiftDetailsSubmitted();
    allowNavigation();
    dispatch(selectDefaultInfoMDB({ jobData }));
    history.push('/dashboard/multi-day/confirm');
  };

  if (isLoading) {
    return <CardSpinner />;
  }

  return (
    <div className="component_container">
      <div
        data-cy="professional-request-form"
        className="floating_container"
        style={{ justifyContent: 'flex-start', flexDirection: 'column' }}
      >
        <div className="card">
          <div style={{ marginTop: 20, marginLeft: 30 }}>
            <BackButton />
          </div>
          <div className="card-body" style={{ margin: 30 }}>
            <ProgressBar step={1} />

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Form
                formValues={formValues}
                setFormValues={setFormValues}
                defaultOpenCardIndex={
                  FORM_FIELDS.PROFESSIONAL
                }
              />
            </div>
          </div>
        </div>
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 120,
            marginTop: 20,
          }}
        >
          <Button
            text="Next"
            onClick={handleNextButton}
            disabled={isButtonDisabled}
            data-testid="next-button"
            dataCy="next-button"
          />
        </div>
      </div>

      {confirmationExitModalOpen && (
        // @ts-expect-error - ConfirmPopup is not typed
        <ConfirmPopup
          Icon={() => <Icon name="warning-outline" size={80} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="Your shifts haven't been posted yet. Leaving now means the progress made to your request won't be saved."
        />
      )}

      <ChargeTimelineDaysPopup screenName="ShiftDetails" />
    </div>
  );
}
